import request from './index.js';

// 公开配置（无需鉴权）：site_name / page_size 等 is_public=1 的键
export function getPublicConfigs() {
    return request.get('/config/public');
}

export function getSystemConfig(params) {
    return request.get('/config/system', { params });
}

export function updateSystemConfig(data) {
    return request.put('/config/system', data);
}

export function refreshCache() {
    return request.post('/config/cache/refresh');
}

// 数据健康检查：扫描孤儿数据与跨表引用完整性
export function runHealthCheck() {
    return request.post('/config/health-check', {}, { timeout: 60000 });
}

// 一键清理孤儿数据
export function cleanupOrphans() {
    return request.post('/config/health-check/cleanup', {}, { timeout: 60000 });
}

// 立即备份数据库一次（mysqldump + gzip，可能耗时数秒）
export function backupNow() {
    return request.post('/config/backup-now', {}, { timeout: 120000 });
}

// 备份状态：开关/时间/保留份数/最近一次结果/备份文件清单
export function getBackupStatus() {
    return request.get('/config/backup-status');
}

// 下载备份文件（blob，返回完整 axios 响应）
export function downloadBackupFile(file) {
    return request.get(`/config/backup-download/${encodeURIComponent(file)}`, { responseType: 'blob', timeout: 120000 });
}

// 删除备份文件
export function deleteBackupFile(file) {
    return request.delete(`/config/backup-file/${encodeURIComponent(file)}`);
}

// 系统资源监控：磁盘/数据库/目录体积/进程状态
export function getSystemResources() {
    return request.get('/config/system-resources', { timeout: 60000 });
}

export function getModelConfigs(params) {
    return request.get('/config/models', { params });
}

export function updateModelConfig(id, data) {
    return request.put(`/config/models/${id}`, data);
}

export function createModelConfig(data) {
    return request.post('/config/models', data);
}

export function deleteModelConfig(id) {
    return request.delete(`/config/models/${id}`);
}

export function updateModelKey(id, data) {
    return request.put(`/config/models/${id}/key`, data);
}

export function testModelConnection(id) {
    return request.post(`/config/models/${id}/test`, {}, { timeout: 45000 });
}

export function testAllModels() {
    return request.post('/config/models/test-all', {}, { timeout: 120000 });
}

export function getLatestVersions() {
    return request.get('/config/models/latest-versions', { timeout: 30000 });
}

export function getModelVersions(id) {
    return request.get(`/config/models/${id}/versions`, { timeout: 30000 });
}
